"use client";
import { useRouter } from "next/navigation";

export default function NotFoundComponent() {
  const router = useRouter();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <h1 className="text-6xl font-bold text-brand-card">404</h1>
      <p className="text-xl text-brand-card/80 mt-4 text-center">
        Not Found - The resource you{"'"}re looking for doesn{"'"}t exist
      </p>
      <button
        onClick={() => router.push("/")}
        className="mt-6 px-6 py-3 bg-brand-grey font-semibold text-brand-card global-border-radius text-2xl"
      >
        Go Back
      </button>
    </div>
  );
}
